"use client";

import { clsx } from "@trydig/ui";
import { Suspense } from "react";
import { FavoriteIcon } from "~/components/icons/16/Favorite";
import { useWishlist } from "~/lib/hooks/useWishlist";
import styles from "./AddToWishlistButton.module.css";

const UnsuspendedAddToWishlistButton = ({ productId }: { productId: string }) => {
	const { toggle, isIncluded } = useWishlist(productId);

	const included = isIncluded();
	return (
		<button
			type="button"
			className={clsx("transparent", "small", styles.wishlistButton, included && styles.active)}
			onClick={() => {
				toggle();
			}}
		>
			<div className={styles.inner__button}>
				<FavoriteIcon filled={included} />
				<span className={styles.text}>{included ? "Din favoritt" : "Favoritt"}</span>
			</div>
		</button>
	);
};

export const AddToWishlistButton: typeof UnsuspendedAddToWishlistButton = (props) => {
	return (
		<Suspense>
			<UnsuspendedAddToWishlistButton {...props} />
		</Suspense>
	);
};
